module.exports = __webpack_public_path__ + "static/media/bonarka12.1509c4b6.jpg";